var _linearGradient, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 40 40"
}, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
  id: "facebook_svg__a",
  x1: -277.375,
  x2: -277.375,
  y1: 406.602,
  y2: 407.573,
  gradientTransform: "matrix(40 0 0 -39.7778 11115.001 16212.334)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#0062e0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#19afff"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#facebook_svg__a)",
  d: "M16.7 39.8C7.2 38.1 0 29.9 0 20 0 9 9 0 20 0s20 9 20 20c0 9.9-7.2 18.1-16.7 19.8l-1.1-.9h-4.4z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m27.8 25.6.9-5.6h-5.3v-3.9c0-1.6.6-2.8 3-2.8H29V8.2c-1.4-.2-3-.4-4.4-.4-4.6 0-7.8 2.8-7.8 7.8V20h-5v5.6h5v14.1q1.65.3 3.3.3t3.3-.3V25.6z"
})));
export { SvgFacebook as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHZpZXdCb3g9IjAgMCA0MCA0MCI+DQogIDxsaW5lYXJHcmFkaWVudCBpZD0iYSIgeDE9Ii0yNzcuMzc1IiB4Mj0iLTI3Ny4zNzUiIHkxPSI0MDYuNjAxOCIgeTI9IjQwNy41NzI2IiBncmFkaWVudFRyYW5zZm9ybT0ibWF0cml4KDQwIDAgMCAtMzkuNzc3OCAxMTExNS4wMDEgMTYyMTIuMzM0KSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPg0KICAgIDxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iIzAwNjJlMCIvPg0KICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMTlhZmZmIi8+DQogIDwvbGluZWFyR3JhZGllbnQ+DQogICAgPHBhdGggZmlsbD0idXJsKCNhKSIgZD0iTTE2LjcgMzkuOEM3LjIgMzguMSAwIDI5LjkgMCAyMCAwIDkgOSAwIDIwIDBzMjAgOSAyMCAyMGMwIDkuOS03LjIgMTguMS0xNi43IDE5LjhsLTEuMS0uOWgtNC40bC0xLjEuOXoiLz4NCiAgICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJtMjcuOCAyNS42LjktNS42aC01LjN2LTMuOWMwLTEuNi42LTIuOCAzLTIuOEgyOVY4LjJjLTEuNC0uMi0zLS40LTQuNC0uNC00LjYgMC03LjggMi44LTcuOCA3LjhWMjBoLTV2NS42aDV2MTQuMWMxLjEuMiAyLjIuMyAzLjMuMyAxLjEgMCAyLjItLjEgMy4zLS4zVjI1LjZoNC40eiIvPg0KPC9zdmc+";